module.exports = __webpack_public_path__ + "static/media/miroslav-400-400.4a377001.webp";